import {Injector} from '@angular/core';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {Location} from '@angular/common';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';

export abstract class NotificationBaseService {

	protected location: Location;
	protected appConfig: AppConfigEnvironmentService;
	protected httpAuthService: HttpAuthService;
	protected environment: AppConfigEnvironment;
	protected messageManagerService: MessageManagerService;

	protected constructor(protected injector: Injector) {
		this.location = injector.get(Location);
		this.appConfig = injector.get(AppConfigEnvironmentService);
		this.httpAuthService = injector.get(HttpAuthService);
		this.messageManagerService = injector.get(MessageManagerService);
		this.environment = this.appConfig.Environment;
	}

	protected get redirectUrl(): string {
		return `${this.environment.ROOT_REDIRECT}?url=${this.location.path()}`;
	}

	protected handleErrorResponse(error: any): void {
		this.messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
	}
}
